export default {
  new: {
    title: 'New',
    create: 'Create invoice',
    import: 'Import invoice'
  },
  financing: 'Financing',
  agenda: 'Directory',
  configuration: {
    title: 'Configuration',
    companyData: 'Company info.',
    users: 'Users management',
    notification: 'Notifications',
    invoiceFormat: 'Invoice format',
    keys: 'WS Integration',
    catalog: 'Catalogue'
  },
  help: {
    title: 'Help',
    manual: 'User manual',
    video: 'Tutorial video',
    support: 'Technical support',
    about: 'About...',
    sefTicketbaiData: 'About SEF-TicketBAI',
    verifactuStatement: 'VERIFACTU statement'
  },
  multiCompany: {
    title: 'MultiCompany'
  },
  header: {
    nif: 'Company name',
    language: 'Language',
    freeAccount: 'Free Account',
    proAccount: 'PRO Account',
    contract: 'Arrange a call now',
    proFunctionalities: {
      title: 'Pro Functionalities',
      subtitle: 'Unlimited invoices',
      func1: 'Send and receive unlimited electronic invoices for public entities, clients and suppliers',
      func2: 'Convert, import and export invoices into different consistent formats',
      func3: 'Ulimited users to manage the system',
      func4: 'Via API integration with your own management structure',
      func5: `Safeguard the original electronic invoices as long as it's needed according to the European and national legal framework`,
      func6: 'Receive real time tracking notifications of invoices status',
      func7: 'Proof of delivery and reception and customized printing',
      func8: 'Obtain induction training to discover all functionalities of the system',
      func9: 'Preferential telephone technical support for the use of the system',
      subscription: 'Premium account',
      success: 'Your request is being processed, we will contact you shortly.',
      error: 'Sorry, an error occurred. Try again later or contact us at:',
      close: 'Close'
    }
  }
}
